module.exports = __webpack_public_path__ + "static/workerselection-89fac6b972902c4bb81ea596ae74e128.png";